<template>
  <div class="img-auth">
    <img src="@/assets/images/graphic3.svg" alt="">
  </div>
</template>

<script>
  import './scss/style.scss'
  export default {
    data () {
      return {}
    },
    methods: {},
    mounted () {}
  }
</script>



// WEBPACK FOOTER //
// src/views/auth/components/img-auth.vue